import React, {useContext, useEffect, useState} from "react";
import moment from "moment";
import DownArrow from "../../icons/DownArrow";
import LoaderCircle from "../../loader/LoaderCircle";
import StringTools from "../../../class/tool/StringTools";
import BackofficeContext from "../../../context/BackofficeContext";
import "moment/locale/fr";
moment.locale('fr');

const ATask = props => {
    const { task } = props;
    const { setTypeDeployProcess } = useContext(BackofficeContext);
    const [ opened, setOpened ] = useState(false);
    const [ state, setState ] = useState("");

    const defineState = () => {
        switch (task.type.toLowerCase()) {
            case "resetprocess":
            case "mainlicensechangingprocess": setState("inProgress"); break;
            default:
                if (task.inProgress.length > 0) setState("inProgress");
                else if (analyzeAvailables()) setState("available");
                else if (task.planned.length > 0 || task.asked.length > 0) setState("asked");
                else if (task.issued.length > 0) setState("issued");
                else if (task.finished.length > 0) setState("finished");
                else setState("");

                break;
        }
    }
    const buildTitle = () => {
        switch (task.type.toLowerCase()) {
            case "catalogdeployments": return "Catalogue à déployer";
            case "catalogtargeteddeployments": return "Catalogue en déploiement";
            case "settingdeployments": return "Ecran de caisse à déployer";
            case "settingtargeteddeployments": return "Ecran de caisse en déploiement";
            case "productimports": return "Import produits";
            case "productexports": return "Export produits";
            case "stockexports": return "Export de stock";
            case "datasasking": return "Export statistiques";
            case "clientimports": return "Import clients";
            case "clientexports": return "Export clients";
            case "resetprocess": return "Remise à zéro d'une licence";
            case "mainlicensechangingprocess": return "Changement de licence principale";
            default: return "";
        }
    }
    const buildSubTitle = () => {
        switch (task.type.toLowerCase()) {
            case "resetprocess":
            case "mainlicensechangingprocess": return "En cours ...";
            case "catalogdeployments":
            case "settingdeployments":
                if (task.inProgress.length > 0) return "En cours ...";
                else if (task.asked.length > 0) return "Demande en attente";
                else if (analyzeAvailables()) return "Demande en attente";
                else if (task.issued.length > 0) return "Erreur rencontrée";
                else if (task.planned.length > 0) return "Déploiement plannifié";
                else if (task.finished.length > 0) return "Terminée";
                else return "";
            default:
                if (task.inProgress.length > 0) return "En cours ...";
                else if (Object.keys(task.available).length > 0) return "Demande en attente";
                else if (task.asked.length > 0) return "La demande va être traitée";
                else if (task.issued.length > 0) return "Erreur rencontrée";
                else if (task.finished.length > 0) return "Terminée";
                break;
        }
    }
    const buildIcon = () => {
        switch (task.type.toLowerCase()) {
            case "resetprocess":
            case "mainlicensechangingprocess": return <LoaderCircle display="loading" strokeWidth="10" stroke="#9C9C9C" />;
            default: return <DownArrow classname={"arrow" + (opened ? " opened" : "")} click={extend} />;
        }
    }
    const buildList = () => {
        switch (task.type.toLowerCase()) {
            case "resetprocess":
            case "mainlicensechangingprocess": return;
            default:
                return <>
                    {buildAvailable()}
                    {buildPlanned()}
                    {buildAsked()}
                    {buildInProgress()}
                    {buildFinished()}
                    {buildIssued()}
                </>;
        }
    }
    const buildAvailable = () => {
        let tasks;

        switch (task.type) {
            case "catalogDeployments":
                tasks = buildAvailableCatalogList(Object.keys(task.available));
                break;
            case "settingDeployments":
                console.log("task.type", task.type);
                console.log("task.available", task.available);
                tasks = buildAvailableScreenList(Object.keys(task.available.posscreens));
                break;
            default:
                return;
        }

        if (tasks.length > 0) {
            return <div className={"block"}>
                <p className={"title available"}>En attente d'instruction</p>
                {
                    tasks.map((op, index) => (
                        <div key={index} className={"op available"} onClick={() => { toDeploy(op) }}>
                            <p className={"description noPaddingBottom"}>{op.description}</p>
                        </div>
                    ))
                }
            </div>;
        }
    }
    const buildAvailableCatalogList = keys => {
        let tasks = [];
        const catalogs = JSON.parse(localStorage.getItem("catalogs"));

        for (let i in keys) {
            if (!task.available[keys[i]].hasUpdates)
                continue;

            const catalog = catalogs.find(_ => _.id === parseInt(keys[i]));
            if (catalog === undefined)
                continue;

            tasks.push({
                "type": "catalog",
                "target_id": catalog.id,
                "target_name": catalog.name,
                "description": "Cliquer pour planifier le déploiement de \"" + catalog.name + "\""
            });
        }

        return tasks;
    }
    const buildAvailableScreenList = keys => {
        let tasks = [];
        const screens = JSON.parse(localStorage.getItem("screens"));

        for (let i in keys) {
            const screen = screens.find(_ => _.id === parseInt(keys[i]));

            if (screen === undefined)
                continue;

            tasks.push({
                "type": "screen",
                "target_id": screen.id,
                "target_name": screen.name,
                "description": "Cliquer pour planifier le déploiement de \"" + screen.name + "\""
            });
        }

        return tasks;
    }
    const buildInProgress = () => {
        if (task.inProgress.length > 0) {
            return <div className={"block"}>
                <p className={"title inProgress"}>En cours</p>
                {
                    task.inProgress.map((op, index) => (
                        <div key={index} className={"op inProgress"}>
                            <p className={"askingDate"}>Demandée le {moment.utc(op.askingDate).local().format("DD MMM YYYY, LT")}</p>
                        </div>
                    ))
                }
            </div>;
        }
    }
    const buildAsked = () => {
        if (task.asked.length > 0) {
            return <div className={"block"}>
                <p className={"title asked"}>Demandées</p>
                {
                    task.asked.map((op, index) => (
                        <div key={index} className={"op asked"} onClick={toDeploy}>
                            <p className={"askingDate"}>Demandée le {moment.utc(op.propose_at).local().format("DD MMM YYYY, LT")}</p>
                        </div>
                    ))
                }
            </div>;
        }
    }
    const buildPlanned = () => {
        if (task.planned.length > 0) {
            return <div className={"block"}>
                <p className={"title planned"}>Planifiées</p>
                {
                    task.planned.map((op, index) => buildPlannedDescription(op, index))
                }
            </div>;
        }
    }
    const buildPlannedDescription = (op, index) => {
        switch (task.type.toLowerCase()) {
            case "catalogdeployments":
            case "catalogtargeteddeployments":
            case "settingdeployments":
            case "settingtargeteddeployments":
                return <div key={index} className={"op planned"}>
                    <p className={"askingDate"}>Déploiement planifié le {moment.utc(op.propose_at).local().format("DD/MM/YYYY à HH:mm")}</p>
                </div>;
            default: return;
        }
    }
    const buildFinished = () => {
        if (task.finished.length > 0) {
            return <div className={"block"}>
                <p className={"title finished"}>Terminées</p>
                {
                    task.finished.map((op, index) => buildFinishedDescription(op, index))
                }
            </div>;
        }
    }
    const buildFinishedDescription = (op, index) => {
        switch (task.type.toLowerCase()) {
            case "productimports":
            case "clientimports":
                const author = JSON.parse(op.author);
                return <div key={index} className={"op finished"}>
                    <p className={"description"}>Par {author.firstname} {author.lastname}</p>
                    <p className={"doneDate"}>Terminée le {moment.utc(op.import_at).local().format("DD MMM YYYY, LT")}</p>
                </div>;
            case "datasasking":
            case "productexports":
            case "stockexports":
            case "clientexports":
                return <div key={index} className={"op finished"}>
                    <p className={"description"}>{(op.askingType !== undefined ? StringTools.capitalizeFirstLetter(op.askingType) + ", " : "")}période : {op.periodDefinition}</p>
                    <p className={"askingDate"}>Demandée le {moment.utc(op.doneDate).local().format("DD MMM YYYY, LT")}</p>
                    <p className={"doneDate"}>Terminée le {moment.utc(op.doneDate).local().format("DD MMM YYYY, LT")}</p>
                </div>;
            case "catalogdeployments":
            case "catalogtargeteddeployments":
            case "settingdeployments":
            case "settingtargeteddeployments":
                return <div key={index} className={"op finished"}>
                    <p className={"doneDate"}>Déployé le {moment.utc(op.deploy_at !== null ? op.deploy_at : op.proposed_at).local().format("DD MMM YYYY, LT")}</p>
                </div>;
            default: return;
        }
    }
    const buildIssued = () => {
        if (task.issued.length > 0) {
            return <div className={"block"}>
                <p className={"title issued"}>Erreur</p>
                {
                    task.issued.map((op, index) => (
                        <div key={index} className={"op issued"}>
                            <p className={"askingDate"}>En erreur le {moment(op.updated_at).format("DD MMM YYYY, LT")}</p>
                        </div>
                    ))
                }
            </div>;
        }
    }
    const extend = () => {
        setOpened(!opened);
    }
    const toDeploy = op => {
        setTypeDeployProcess(op);
    }
    const analyzeAvailables = () => {
        if (checkAvailableForTask(task))
            return true;

        return false;
    }
    const checkAvailableForTask = backgroundTask => {
        const keys = Object.keys(backgroundTask.available);

        switch (backgroundTask.type) {
            case "catalogDeployments":
            case "catalogTargetedDeployments":
                for (let j in keys) {
                    if (backgroundTask.available[keys[j]].hasUpdates)
                        return true;
                }

                break;
            case "settingDeployments":
            case "settingTargetedDeployments":
                if (keys.length > 0 && keys[0] === "posscreens") {
                    const internalKeys = Object.keys(backgroundTask.available["posscreens"]);

                    for (let j in internalKeys) {
                        if (backgroundTask.available["posscreens"][internalKeys[j]].hasUpdates)
                            return true;
                    }
                }

                break;
            default: break;
        }
    }

    useEffect(() => {
        defineState();
    }, [task]);

    return (
        <div className={"aTask"}>
            <div className={"header" + (state.length > 0 ? " " + state : "")}>
                <div className={"containerTitle"}>
                    <p className={"title"}>{buildTitle()}</p>
                    <p className={"subtitle"}>{buildSubTitle()}</p>
                </div>
                {buildIcon()}
            </div>
            <nav className={"list" + (opened ? " opened" : "")}>
                {buildList()}
            </nav>
        </div>
    );
}

export default ATask;